<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="13.5" y="13.5" width="5" height="5" rx="0.5" fill="var(--bg-color)" stroke="var(--icon-color)" />
    <rect x="5.5" y="13.5" width="5" height="5" rx="0.5" fill="var(--bg-color)" stroke="var(--icon-color)" />
    <rect x="21.5" y="13.5" width="5" height="5" rx="0.5" fill="var(--bg-color)" stroke="var(--icon-color)" />
</svg>

